import api from "../../utils/helpers/api";

export const postLogin = (headers, data) => {
  return api({
    method: "post",
    url: "/api/v1/auth/signin",
    noAuth: true,
    data,
    headers,
  });
};

export const postRegister = (data) => {
  return api({
    method: "post",
    url: "/api/v1/auth/signup",
    noAuth: true,
    data,
  });
};

export const verifyEmail = (headers, data) => {
  return api({
    method: "put",
    url: "/api/v1/auth/verify-email",
    noAuth: true,
    data,
    headers,
  });
};

export const LoginAccount = (data = {}) => {
  const option = {
    method: "post",
    url: "/auth/login",
    data,
    noAuthentication: true,
  };
  return api(option);
};

export const LoginAccountViaFbGg = (data = {}) => {
  const option = {
    method: "post",
    url: "/account/loginOauth2",
    data,
    noAuthentication: true,
  };
  return api(option);
};

export const sendSignupOTP = (data = {}) => {
  const option = {
    method: "post",
    url: "/account/sendSignupOTP",
    data,
    noAuthentication: true,
  };
  return api(option);
};

export const signupAccount = (data = {}) => {
  const option = {
    method: "post",
    url: "/account/signupV2",
    data,
    noAuthentication: true,
  };
  return api(option);
};

export const getTokenForSystem = (data = {}) => {
  const option = {
    method: "post",
    url: "/customer-engagement/login/oauth2",
    data,
    noAuthentication: true,
  };
  return api(option);
};

export const logout = () => {
  const option = {
    method: "delete",
    url: "/auth/v2/logout",
  };
  return api(option);
};

export const sendForgotPasswordOTP = (data = {}) => {
  const option = {
    method: "post",
    url: "/ams/account/forget-password/v2",
    data,
    noAuthentication: true,
  };
  return api(option);
};

export const forgotPasswordV2 = (data = {}) => {
  const option = {
    method: "post",
    url: "/ams/account/otp-set-password",
    data,
    noAuthentication: true,
  };
  return api(option);
};
